import { Image, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowCIPOEvdListaEvidencijaHeader: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  naziv: string;
  type: string;
}> = ({ datum, fullname, potpis, naziv, type }) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{type}</Text>
    </View>
  </View>
);

export const TableRowCIPOEvdListaEvidencija: React.FC<{
  datum: string;
  fullname: string;
  potpis: string;
  naziv: string;
  type: string;
}> = ({ datum, fullname, potpis, naziv, type }) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{naziv}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{type}</Text>
    </View>
  </View>
);
